module.exports = require("clipboard-copy");